function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 6007.78,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M36299 41802l0 -11014 15379 -15379c1113,-1114 1446,-2788 843,-4243 -602,-1456 -2022,-2405 -3596,-2405l-36265 0c-1574,0 -2994,949 -3596,2405 -602,1455 -269,3129 843,4243l15379 15379 0 22027 11014 -11014zm8260 33041l35794 0m-35804 -16520l35804 0m-27544 -16520l27544 0m-22038 -16520l27534 0c3041,0 5507,2466 5507,5507l0 55068c0,3041 -2466,5507 -5507,5507l-49561 0c-3042,0 -5507,-2466 -5507,-5507l0 -22027"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 100124 100124",
    className: "icon",
    style: {
      "height": "1em",
      "width": "1em"
    }
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/filters.ada83fc7.svg";
export { SvgComponent as ReactComponent };